import React, { useCallback, useEffect, useRef, useState } from 'react';
import 'keen-slider/keen-slider.min.css';
import { observer } from 'mobx-react';
import classnames from 'classnames';
import MediaList from '@organisms/media/mobile/MediaList';
import MediaDetail from '@organisms/media/mobile/MediaDetail';
import { has as _has, isEmpty as _isEmpty } from 'lodash';
import { useMobxStores } from '@stores/store';
import queryString from 'query-string';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import moment from 'moment/moment';
import i18n from 'i18next';
import NoticeLabel from '@atoms/NoticeLabel';

const NoticeBox = ({ data }) => {
  const { i18n, t } = useTranslation();
  const now = moment();
  return (
    <>
      <ul className="text-xs xxs:text-sm xs:text-xl ">
        {data.map((row, index) => (
          <li
            className="py-4  xs:py-4 lg:py-6 border-b-[1px] border-[#f1f1f1] border-solid"
            key={`notice_${index}`}
          >
            <Link
              to={`/${i18n.language}/community/news/${row.idx}`}
              className=" relative flex items-center justify-between"
            >
              <span className=" flex items-center w-[80%] inline-block truncate text-[#3d3d3d]">
                <NoticeLabel
                  text={
                    row[
                      `${i18n.language === 'kr' ? 'ko' : i18n.language}Category`
                    ]
                  }
                  addClass={'min-w-[50px] md:min-w-[70px] lg:min-w-[80px]'}
                />
                {now.diff(row.startDt, 'days') < 8 && (
                  <span className="text-[#e5a3f9] underline decoration-1 px-1 xs:px-2 font-sans">
                    NEW
                  </span>
                )}
                <span className="inline-block w-full  text-ellipsis overflow-hidden text-[#3d3d3d] ">
                  {row.title}
                </span>
              </span>

              <span className="text-[#b0b0b0] sm:text-lg ">
                {moment(`${row.startDt}`).format('MM.DD')}
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </>
  );
};

export default observer(NoticeBox);
